<template>
  <div>
    <md-card id="diagnoses" class="md-with-hover">

      <md-card-header class="md-card-header-icon md-card-header-warning">
        <div class="card-icon">
          <md-icon>manage_search</md-icon>
        </div>
        <h4 class="title" style="font-weight: 400;display: flex;align-items: center;gap: 10px;">ICD10
          <md-progress-spinner v-if="isLoading" :md-diameter="30" :md-stroke="3"
            md-mode="indeterminate"></md-progress-spinner>
        </h4>
      </md-card-header>

      <md-card-content :style="isLoading ? 'opacity:0.5;pointer-events:none' : ''">
        <div class="md-layout">
          <div class="md-layout-item">&nbsp;</div>
        </div>
        <hr>

        <div class="main-content">
          <div class="icd10-section">
            <div class="title">ICD10 list</div>
            <VueMultiselectComponent class="multi-select" v-model="selectedICD10" :disabled="isLoading"
              :options="optionsICD10" track-by="id" placeholder="Select one or more ICD-10 codes" />
          </div>
          <div class="icd10-section">
            <div class="title">CPT list</div>
            <VueMultiselectComponent class="multi-select" v-model="selected" :disabled="isLoading" :options="options"
              track-by="id" placeholder="Select one or more ICD-10 codes" />
          </div>
          <div>
            <div class="title">ICD10 Description</div>
            <div class="description-box">
              {{ selectedDescription || "Description will appear here" }}
            </div>
          </div>
        </div>
      </md-card-content>
    </md-card>
  </div>
</template>

<script>
import icd10Service from "../../../services/icd10-service";
import cptService from "../../../services/cpt-service";
import { mapGetters } from "vuex";
import VueMultiselectComponent from 'vue-multiselect-component'
import { bus } from "@/main"

export default {
  name: "icd10",
  components: {
    VueMultiselectComponent
  },
  props: {
    isLoading: false,
  },
  data() {
    return {
      selectedICD10: [],
      optionsICD10: [],
      selected: [],
      options: [],
      selectedDescription: '',
      icd10List: [],
      cptList: [],
      cptRelationsList: []
    }
  },
  methods: {
    async loadICD10List() {
      try {
        this.icd10List = await icd10Service.getICD10List();
        this.optionsICD10 = this.icd10List.map(item => ({
          id: item.CODE,
          label: `${item.CODE} - ${item.Diagnosis}`,
          description: item.Description
        }));
      } catch (error) {
        console.error(error);
      }
    },
    async loadCPTList() {
      if (this.screening && this.screening.orgID && !this.cptList.length) {
        try {
          this.cptList = await cptService.getCPTList(this.screening.orgID);
          this.options = this.cptList.map(item => ({
            id: item.code,
            label: `${item.code} - ${item.description}`,
            cptID: item.id,
          }));
        } catch (error) {
          console.error(error);
        }
      }
    },
    async loadCPTRelationsList() {
      if (this.screening && this.screening.orgID && !this.cptRelationsList.length) {
        try {
          this.cptRelationsList = await cptService.getCPTRelationsList(this.screening.orgID);
        } catch (error) {
          console.error(error);
        }
      }
    },
    formatDiagnoses(diagnoseTxt) {
      return diagnoseTxt.split(/\n/).map(d => d.trim()).filter(Boolean);
    },
    updateICD10State(icd10List) {
      this.$store.commit('updateICD10State', icd10List);
    },
    updateCPTState(cptList) {
      this.$store.commit('updateCPTState', cptList);
    },
  },
  created() {
    this.loadICD10List();
    bus.$on("clearDxOptions", () => {
      this.selectedICD10 = [];
      this.selected = [];
      this.selectedDescription = '';
    })
  },
  watch: {
    selectedICD10(newSelection) {
      if (newSelection && newSelection.length > 0) {
        const descriptions = [];
        const allRelatedCpts = new Set();

        newSelection.forEach(selected => {
          const selectedId = typeof selected === 'object' && selected.id ? selected.id : selected;
          const detailedInfo = this.icd10List.find(item => item.CODE === selectedId);
          if (detailedInfo) {
            descriptions.push(detailedInfo.Description);
            const relatedCpts = this.cptRelationsList
              .filter(rel => rel.icd10Id === Number(detailedInfo.ID))
              .map(rel => rel.cptId);
            relatedCpts.forEach(id => allRelatedCpts.add(id));
          }
        });

        const finalCptList = Array.from(allRelatedCpts);
        this.options = this.cptList
          .filter(option => finalCptList.includes(option.id))
          .map(o => ({
            id: o.code,
            label: `${o.code} - ${o.description}`,
            cptID: o.id,
          }));
        this.selected = this.options.map(o => o.id);

        this.selectedDescription = descriptions.join(', ');

        const icd10ListHere = newSelection.map(selected => {
          const selectedId = typeof selected === "object" && selected.id ? selected.id : selected;
          const detailedInfo = this.icd10List.find(item => item.CODE === selectedId);

          return {
            code: detailedInfo.CODE,
            description: detailedInfo.Description
          };
        });
        this.updateICD10State(icd10ListHere);

      } else {
        this.selectedDescription = "Description will appear here";
        this.options = this.cptList.map(o => ({
          id: o.code,
          label: `${o.code} - ${o.description}`,
          cptID: o.id,
        }));
        this.selected = [];
        this.updateICD10State([]);
      }
    },
    selected(newSelection) {
      const formattedCPTList = newSelection.map(s => {
        const foundItem = this.options.find(item => item.id === s);
        return {
          code: s,
          description: foundItem.label
        };
      });
      this.updateCPTState(formattedCPTList);
    },
    screening: {
      async handler(newVal) {
        if (newVal) {
          this.loadCPTList();
          this.loadCPTRelationsList();
        }
      }
    },
    'evalResults.diagnoseTxt': {
      async handler(newVal) {
        if (newVal) {
          const diagnosesArray = this.formatDiagnoses(newVal)
          try {
            const suggestions = await icd10Service.getSuggestions(diagnosesArray)
            for (const s of suggestions) {
              if (!this.icd10List.find(i => i.CODE === s.CODE)) {
                this.icd10List.push(s);
              }
            }
            this.optionsICD10 = this.icd10List.map(item => ({
              id: item.CODE,
              label: `${item.CODE} - ${item.Diagnosis}`,
              description: item.Description
            }));
            this.selectedICD10 = []
            this.selectedICD10 = Array.from(new Set(suggestions
              .filter(suggestion => suggestion !== null)
              .map(suggestion => suggestion.CODE)))
          } catch (error) {
            console.error(error)
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters(["ddFinalDiagnoses", "evalResults", "icd10State", "cptState", "screening"]),
    evalResultsDebug() {
      return this.evalResults;
    }
  }
}
</script>

<style lang="scss" scoped>
#diagnoses {
  width: 95%;
  margin-left: 20px;
  display: inline-block;
  vertical-align: top;
}

.container {
  display: flex;
  flex-direction: column;
  /* Align children vertically */
  align-items: center;
  /* Optionally align the children horizontally in the center */
  gap: 20px;
  /* Optional: Adjust the space between the items */
  margin-top: 20px;
  /* Add space from the top */
  margin-bottom: 20px;
  /* Add space from the bottom */
}

.md-field label {
  top: 0
}

.multi-select {
  min-width: 50%;
}

.main-content {
  display: flex;
  flex-direction: column;
  margin: 2rem 0;
  gap: 16px;
}

.icd10-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.title {
  font-size: 16px;
  font-weight: bold;
}

.description-box {
  border: 1px solid rgb(204, 212, 221);
  min-height: 50px;
  padding: 12px;
  border-radius: 6px;
  line-height: 0.97rem;
  font-size: 0.8rem;
  font-style: italic;
  color: rgb(126, 126, 126);
}
</style>
